import { withProps } from 'recompose';
import Item from './Item';
import { formatFullDate } from '../../utils/format';

const DateItem = withProps(({ value }) => ({ value: formatFullDate(value) }))(Item);

export default DateItem;
